import * as gen from '@src/assets/js/api.js'
import axios from 'axios'
const state = {
  buildType: process.env.NODE_ENV
}
const getters = {
  baseUrl(state) {
    let baseUrl
    switch (state.buildType) {
      case 'production': //生产
        baseUrl="https://followup.huidr.com/api"
        break;
      case 'development': //开发
        // baseUrl="http://192.168.1.176:120"
        // baseUrl="http://192.168.1.180:1046"
        baseUrl="/api"
        // baseUrl="http://192.168.1.107:1046"
        break;
      case 'test': //测试
        baseUrl="http://qc.test.huidr.com/api"
        break;
    }
    return baseUrl
  }
}

const actions = {
  /**
   *
   * @param commit
   * @param options: { fn: 'xxxx',params: { a: 1, b: 2}}
   * @returns {Promise<*>}
   */
  async requestHandler({commit},options) {
    let request = new gen[options.fn]
    for(let k in options.params) {
      request['p_' + k] = options.params[k]
    }
    await request.send()
    return request.result
  },
  async uploadRequestHandler({commit},options) {
    console.log(`${ options.url} ${options.formData}`);
    let result = await axios({
      url:  options.url,
      method: 'post',
      data: options.data,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
    return result
  }
}
export default {
  actions,
  getters,
  state
}